import { css } from "@emotion/react";

export const useStyles = () => {
  return {
    strip: css`
      background: none;
    `,
  };
};
